var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#155C8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.608V24.75C30 26.483 28.6435 27.8992 26.9344 27.9949L26.75 28H13.25C11.517 28 10.1008 26.6435 10.0051 24.9344L10 24.75V16.608L19.652 21.6644C19.87 21.7785 20.13 21.7785 20.348 21.6644L30 16.608ZM13.25 12H26.75C28.4347 12 29.8201 13.2819 29.9838 14.9236L20 20.1533L10.0162 14.9236C10.1739 13.3427 11.4643 12.0954 13.0641 12.0052L13.25 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailIcon);
export default __webpack_public_path__ + "static/media/EMailIcon.64af8855419ecfabf6d41bbbe5d5588d.svg";
export { ForwardRef as ReactComponent };